import { render, staticRenderFns } from "./WorkPlaceAddNew.vue?vue&type=template&id=6fb85cd6"
import script from "./WorkPlaceAddNew.vue?vue&type=script&lang=js"
export * from "./WorkPlaceAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports